import { DetailedRequisitionSerializer } from "../../recoil/types";
import {
  formatWithTimezoneOffset,
  getWeeksDiffGestation,
  parseYmdAtNoonUtc,
} from "../../utils/helpers";

const includesCarrierScreen = (testsOrdered: string): boolean =>
  /carrier screen/i.test(testsOrdered);

export const getScreenNotes = (
  testsOrdered: string,
  generateNotesModalOpen: DetailedRequisitionSerializer,
): string => {
  if (
    includesCarrierScreen(testsOrdered) &&
    !testsOrdered.includes("Aneuploidy")
  ) {
    return `${generateNotesModalOpen.first_name} ${
      generateNotesModalOpen.last_name
    }, born on ${formatWithTimezoneOffset(
      generateNotesModalOpen.date_of_birth!,
    )}${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? ` and is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ","
    } was seen on ${formatWithTimezoneOffset(generateNotesModalOpen.collection_date!)}.  The patient was referred to BillionToOne for the Unity™ Screen Test. BillionToOne is the only lab that can do direct fetal risk assessment for ACOG-recommended recessive genetic conditions without testing the father of the pregnancy and is, therefore, medically necessary for this patient.

I’m writing to inform you that my patient${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? `, who is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ""
    } has not had sufficient genetic carrier screening to my knowledge. They have been counseled on the potential results, benefits, and limitations of genetic carrier screening, and has decided to proceed. 

Importantly, your network of laboratories does not include an in-state or out-of-state laboratory that can provide informative screening for recessive conditions for this pregnancy without subsequent paternal testing and/or invasive procedures for the pregnant patient.`;
  }
  if (
    testsOrdered.includes("Aneuploidy Only") &&
    !testsOrdered.includes("Rh")
  ) {
    return `${generateNotesModalOpen.first_name} ${
      generateNotesModalOpen.last_name
    }, born on ${formatWithTimezoneOffset(
      generateNotesModalOpen.date_of_birth!,
    )}${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? ` and is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ","
    } was seen on ${formatWithTimezoneOffset(generateNotesModalOpen.collection_date!)}. We discussed genetic screening options for this pregnancy, including Aneuploidy screening per ACOG guidelines, which supports NIPT for all pregnant patients regardless of maternal age or family history. The patient was counseled on the potential results, benefits, and limitations of the screen.

The patient was referred to BillionToOne for the Unity Screen Test, which assesses fetal risk for ACOG-recommended chromosome abnormalities via cell-free DNA.`;
  }
  if (
    includesCarrierScreen(testsOrdered) &&
    testsOrdered.includes("Aneuploidy") &&
    !testsOrdered.includes("Rh")
  ) {
    return `${generateNotesModalOpen.first_name} ${
      generateNotesModalOpen.last_name
    }, born on ${formatWithTimezoneOffset(
      generateNotesModalOpen.date_of_birth!,
    )}${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? ` and is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ","
    } was seen on ${formatWithTimezoneOffset(generateNotesModalOpen.collection_date!)}. The patient was referred to BillionToOne for the Unity™ Screen Test. BillionToOne is the only lab that can do direct fetal assessment for ACOG-recommended recessive genetic conditions without testing the father of the pregnancy and is, therefore, medically necessary for this patient.

I’m writing to inform you that my patient${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? `, who is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ""
    } has not had sufficient genetic carrier screening to my knowledge. They have been counseled on the potential results, benefits, and limitations of genetic carrier screening and aneuploidy screening and has decided to proceed.

Importantly, your network of laboratories does not include an in-state or out-of-state laboratory that can provide informative screening for recessive conditions for this pregnancy without subsequent paternal testing and/or invasive procedures for the pregnant patient.  `;
  }
  if (testsOrdered.includes("Aneuploidy Only") && testsOrdered.includes("Rh")) {
    return `${generateNotesModalOpen.first_name} ${
      generateNotesModalOpen.last_name
    }, born on ${formatWithTimezoneOffset(
      generateNotesModalOpen.date_of_birth!,
    )}${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? ` and is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ","
    } was seen on ${formatWithTimezoneOffset(generateNotesModalOpen.collection_date!)}. The patient is RhD negative, and we discussed genetic screening options for this pregnancy, including Aneuploidy screening per ACOG guidelines and NIPT for fetal RhD status. The patient was counseled on the potential results, benefits, and limitations of the screen.

The patient was referred to BillionToOne for the Unity Screen Test because your network of laboratories does not include an in-state or out-of-state laboratory that can provide direct fetal assessment for RhD status and assess fetal risk for ACOG recommended chromosome abnormalities via cellfree DNA. BillionToOne is the only lab in the US that can do NIPT for RhD status and fetal risk for recommended chromosome abnormalities via cell-free DNA and is, therefore, medically necessary for this patient.`;
  }
  if (
    includesCarrierScreen(testsOrdered) &&
    testsOrdered.includes("Aneuploidy") &&
    testsOrdered.includes("Rh")
  ) {
    return `${generateNotesModalOpen.first_name} ${
      generateNotesModalOpen.last_name
    }, born on ${formatWithTimezoneOffset(
      generateNotesModalOpen.date_of_birth!,
    )}${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? ` and is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ","
    } was seen on ${formatWithTimezoneOffset(generateNotesModalOpen.collection_date!)}. The patient was referred to BillionToOne for the Unity™ Screen Test. BillionToOne is the only lab in the United States that can do NIPT for fetal RhD status, fetal risk for recommended chromosome abnormalities via cell-free DNA, and screening for recessive conditions for this pregnancy without testing the father of the pregnancy and is, therefore, medically necessary for this patient.

I’m writing to inform you that my patient${
      generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
        ? `who is ${getWeeksDiffGestation(
            parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
            parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
          )} weeks pregnant,`
        : ""
    } has not had sufficient genetic carrier screening to my knowledge. They have been counseled on the potential results, benefits, and limitations of genetic carrier screening, aneuploidy screening, and fetal RhD and has decided to proceed.

Importantly, your network of laboratories does not include an in-state, or out-of-state laboratory that can provide screening for recessive conditions and fetal RhD risk for this pregnancy without subsequent paternal testing and/or invasive procedures for the pregnant patient. `;
  }
  return `${generateNotesModalOpen.first_name} ${
    generateNotesModalOpen.last_name
  }, born on ${formatWithTimezoneOffset(
    generateNotesModalOpen.date_of_birth!,
  )}${
    generateNotesModalOpen.due_date && generateNotesModalOpen.is_pregnant
      ? ` and is ${getWeeksDiffGestation(
          parseYmdAtNoonUtc(generateNotesModalOpen.due_date!),
          parseYmdAtNoonUtc(generateNotesModalOpen.collection_date!),
        )} weeks pregnant,`
      : ","
  } was seen on ${formatWithTimezoneOffset(
    generateNotesModalOpen.collection_date!,
  )}. We discussed genetic screening options for this pregnancy including Carrier screening per ACOG guidelines. The patient was counseled on the potential results, benefits and limitations of the screen.

Patient was referred to BillionToOne for the Unity Test as it is the only lab that can do direct fetal assessment for recessive conditions without a paternal sample.`;
};

export const PROVIDER_LETTER_TITLE =
  "Petition to State Attorney General from Healthcare Providers";

export const getProviderLetter = (): string => `${PROVIDER_LETTER_TITLE}
Dear State Attorney General,
We, the undersigned healthcare providers, respectfully request that your office open an investigation into Laboratory Corporation of America ("Labcorp")'s recent blood draw policies and their impact on patient access to prenatal screening and provider choice.
We understand that Labcorp has instructed its in-office phlebotomists not to collect blood for BillionToOne's Unity prenatal test. This change is deeply concerning because it limits our ability to offer the testing we determine is most appropriate for our patients. Unity offers clinical advantages that other non-invasive prenatal tests ("NIPTs"), including Labcorp's MaterniT21 test, do not.
For many years, patients were able to complete all of their routine prenatal blood work during a single visit through courtesy blood draws. Labcorp's decision to discontinue this longstanding practice has created unnecessary barriers to care, often requiring patients to schedule an additional appointment during the limited 9-12 week prenatal screening window. These additional logistical burdens may delay or discourage patients from receiving the prenatal screening selected by their healthcare provider.
As treating clinicians, we believe decisions regarding laboratory testing should remain between providers and their patients. Operational policies that make it more difficult to access clinically appropriate testing undermine provider choice and interfere with patients' ability to receive the care their physicians recommend.
We respectfully urge your office to investigate Labcorp's blood draw policies and determine whether these practices unfairly restrict patient access to prenatal screening and interfere with providers' independent clinical judgment.
Thank you for your consideration of this important matter.
Respectfully,
The Undersigned Healthcare Providers`;
